import theme from 'theme/theme';

export default {
    bar: {
        backgroundColor: theme.palette.pipi,
        bottom: 0,
        boxShadow: `0px -2px 10px 0px ${ theme.palette.aluminium }`,
        left: 0,
        padding: '8px',
        position: 'fixed',
        right: 0,
        zIndex: 10000,

        description: {
            fontSize: '14px',
        },

        info: {
            display: 'flex',
            justifyContent: 'space-between',
        },

        link: {
            color: 'black',
            textDecorationStyle: 'dashed',
        },

        title: {
            padding: '0 0 5px',
        },
    },

    box: {
        backgroundColor: theme.palette.pipi,
        boxShadow: `0px 0px 5px 0px ${ theme.palette.aluminium }`,
        flexAlignItem: 'center',
        margin: '8px',
        padding: '8px',
        position: 'relative',
        textAlign: 'center',
        width: '300px',

        description: {
            fontSize: '12px',
        },

        link: {
            color: 'black',
            display: 'block',
            padding: '10px 0',
            width: '100%',
            textDecorationStyle: 'dashed',
        },

        title: {
            fontSize: '14px',
            padding: '0 30px 5px',
        },
    },

    button: {
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 0,
        color: theme.palette.redOrange,
        fontSize: '30px',
        fontWeight: 300,
        lineHeight: '30px',
        position: 'absolute',
        right: '-1px',
        top: '-1px',
        transform: 'rotate(45deg)',
    },

    title: {
        borderBottom: `1px solid ${ theme.palette.redOrange }`,
        boxSizing: 'border-box',
        fontWeight: 600,
        marginBottom: '5px',
        width: '100%',
    },
};



// WEBPACK FOOTER //
// ./src/components/layout/OutdatedBrowser/styles.js